export default "__VITE_ASSET__BknMoIIp__"